import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=5ea4f39d&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=5ea4f39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4f39d",
  null
  
)

export default component.exports